module.exports = __webpack_public_path__ + "img/reaktif.924171dd.svg";